module.exports = __webpack_public_path__ + "img/xytl.8e7830d9.png";